import { render } from "./AiAnswer.vue?vue&type=template&id=26130ecb"
import script from "./AiAnswer.vue?vue&type=script&lang=js"
export * from "./AiAnswer.vue?vue&type=script&lang=js"

import "./AiAnswer.vue?vue&type=style&index=0&id=26130ecb&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiAnswer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26130ecb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26130ecb', __exports__)) {
    api.reload('26130ecb', __exports__)
  }
  
  module.hot.accept("./AiAnswer.vue?vue&type=template&id=26130ecb", () => {
    api.rerender('26130ecb', render)
  })

}


export default __exports__